import { forwardRef, Ref, type SVGProps } from 'react';

const SvgMapIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m7.5 15-5.833 3.333V5L7.5 1.667M7.5 15l5.834 3.333M7.5 15V1.667m5.834 16.666 5-3.333V1.667l-5 3.333m0 13.333V5m0 0L7.5 1.667"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMapIcon);
export default ForwardRef;
